import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { PropsWithChildren } from "react";
import NotAuthenticated from "./NotAuthenticated";
import { RoleProvider } from "./RoleProvider";
import LoadingPanel from "../Layout/LoadingPanel";

export default function EnsureAuthentication({ children }: PropsWithChildren<unknown>) {
  const { inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (accounts.length === 0 || inProgress !== InteractionStatus.None) {
    return <LoadingPanel isLoading />;
  }

  return isAuthenticated ? <RoleProvider>{children}</RoleProvider> : <NotAuthenticated />;
}
